import { ROUTES } from '../../constants/routes';
import { StatusMessage } from './types';

import ChargingStatusIcon from '../../assets/icons/chargingStatusIcon.svg?react';
import FinishedStatusIcon from '../../assets/icons/finishedStatusIcon.svg?react';
import PendingStatusIcon from '../../assets/icons/pendingStatusIcon.svg?react';
import FailedStatusIcon from '../../assets/icons/failedStatusIcon.svg?react';

export const getUrlForRequest = (path: string) => {
  switch (path) {
    case ROUTES.CAB_SESSIONS:
      return `/${path}`;
    case ROUTES.CAB_TRANSACTIONS:
      return `/${path}/my`;
    default:
      return '';
  }
};

export const renderStatusMessage = (status: string): StatusMessage => {
  const statusMap: Record<string, StatusMessage> = {
    finished: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    success: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    Finishing: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    active: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    charging: { icon: <ChargingStatusIcon />, backgroundColor: 'blue.main' },
    Charging: { icon: <ChargingStatusIcon />, backgroundColor: 'blue.main' },
    pending: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    Preparing: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    SuspendedEV: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    SuspendedEVSE: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    Available: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    Faulted: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    in_use: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    prepare: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    paused: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    closed: { icon: <FinishedStatusIcon />, backgroundColor: 'success.main' },
    // A start that never became a charge. Not a success, whatever the 0.00 kWh
    // row looks like.
    cancelled: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    failed: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    refund: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    expired: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    // Raw Monobank invoice statuses, stored verbatim by the payment webhook
    // (StatusTransactionEnum). They reach this list like any other status and
    // had no entry here at all, so a payment still in flight was painted the
    // same red as one that failed.
    created: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    processing: { icon: <PendingStatusIcon />, backgroundColor: 'orange.main' },
    failure: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
    reversed: { icon: <FailedStatusIcon />, backgroundColor: 'error.main' },
  };

  return statusMap[status] || { icon: <FailedStatusIcon />, backgroundColor: 'error.main' };
};
